import { useContext } from "react";
import { RootContext } from "../contexts/root.context";

export const useControllers = () => {
  return useContext(RootContext).$children;
};
